import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from './Navbar.module.scss'
import { images } from 'assets'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { actions } from 'slices/app.slice'
import { faHome, faSignOutAlt } from '@fortawesome/free-solid-svg-icons'
import { isAdmin } from '../../utils/functions'
import useScopes from 'hooks/useScopes'
import { useState } from 'react'
import classNames from 'classnames'
import { Divider, Typography } from 'antd'
import SettingsModal from 'pages/dashboard/SettingsModal'

const Navbar = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const params = useLocation()


  const query = new URLSearchParams(params.search)
  const patientId = query.get('id')
  const owner = query.get('owner')

  // get id from url
  const id = params.pathname.split('/')[2]


  const { isAdmin: isAdminScope } = useScopes()

  const { me } = useSelector((state) => state.app)
  const [settingModal, setSettingModal] = useState(false)

  const toggle = () => setSettingModal((v) => !v)
  const handleLogout = () => {
    console.log('logout in navbar')
    dispatch(actions.logout())
  }

  const handleMedicalTabNavigation = () => {
    const queryParams = owner ? `?owner=${owner}` : '';
    navigate(`/medical-tab/${patientId}${queryParams}`);
  };

  const handleMedicalNotesTabNavigation = () => {
    const queryParams = owner ? `?owner=${owner}` : '';
    navigate(`/medical-notes-tab/${patientId}${queryParams}`);
  }

  // ** Root
  return (
    <div className={styles.root}>
      <div className={styles.topRow}>
        <div className={styles.navigation}>
          <button
            type="button"
            onClick={() => {
              navigate('/dashboard')
            }}
            className="text-white"
          >
            Home
          </button>
          <Divider type="vertical" style={{ backgroundColor: 'white' }} />
          <button
            className="text-white"
            type="button"
            onClick={() => {
              navigate('/prescription-tracking')
            }}
          >
            Prescription Tracking
          </button>

          <Divider type="vertical" style={{ backgroundColor: 'white' }} />
          <button
            className="text-white"
            type="button"
            onClick={() => {
              navigate('/lab-support')
            }}
          >
            Lab VIP Support
          </button>

          <Divider type="vertical" style={{ backgroundColor: 'white' }} />
          {/* <Divider type="vertical" style={{ backgroundColor: 'white' }} /> */}
          <button
            className="text-white"
            type="button"
            onClick={() => {
              navigate('/lab-tracking')
            }}
          >
            Lab Tracking
          </button>

          <Divider type="vertical" style={{ backgroundColor: 'white' }} />
          <button
            className="text-white"
            type="button"
            onClick={() => {
              navigate('/medical-note')
            }}
          >
            Medical Note Tracking
          </button>
          <Divider type="vertical" style={{ backgroundColor: 'white' }} />
          <button
            className="text-white"
            type="button"
            onClick={() => {
              navigate('/physio-panel')
            }}
          >
            Physio
          </button>
          {isAdminScope && <><Divider type="vertical" style={{ backgroundColor: 'white' }} />
            <button
              className="text-white"
              type="button"
              onClick={() => {
                navigate('/logs/events')
              }}
            >
              Logs
            </button></>}
          <Divider type="vertical" style={{ backgroundColor: 'white' }} />
          {isAdmin() && (
            <button
              type="button"
              onClick={toggle}
              className={classNames(
                styles.title,
                'd-flex align-items-center justify-content-center',
              )}
            >
              <img
                src={images.setting}
                alt="setting"
                className={styles.logox}
              />
            </button>
          )}

        </div>
        <span className={styles.title}>YDO - {me.doctorName}</span>
        {isAdminScope && location.pathname === '/dashboard' && (
          <Typography.Text
            strong
            underline
            className={styles.title}
            style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '15px', cursor: 'pointer' }}
            onClick={() => navigate('/home')}
          >
            Switch to mental health provider
          </Typography.Text>
        )}
        <button className={styles.title} onClick={handleLogout} type="button">
          <FontAwesomeIcon
            icon={faSignOutAlt}
            color="#ffffff"
            className={styles.logox}
          />
        </button>
      </div>
      {
        !(id || patientId) && (
          <div className={styles.bottomRow} />
        )
      }
      {
        patientId ? (
          <div className={styles.bottomRow}>
            <div className={styles.medicalNavigation}>
              <button
                type="button"
                onClick={handleMedicalTabNavigation}
                style={{
                  color: '#df7467', fontWeight: 600, fontFamily: 'Source Sans Pro'
                }}
              >
                Medication Tab
              </button>
              <Divider type="vertical" style={{ backgroundColor: 'red' }} />
              <button
                type="button"
                onClick={handleMedicalNotesTabNavigation}
                style={{
                  color: '#df7467', fontWeight: 600, fontFamily: 'Source Sans Pro'
                }}
              >
                Medical Notes Tab
              </button>
            </div>
          </div>
        ) : (
          id && (
            <div className={styles.bottomRow}>
              <div className={styles.medicalNavigation}>
                <button
                  type="button"
                  onClick={() => {
                    const queryParams = owner ? `?id=${id}&owner=${owner}` : `?id=${id}`;
                    navigate(`/patient${queryParams}`);
                  }}
                  style={{
                    color: '#df7467', fontWeight: 600, fontFamily: 'Source Sans Pro'
                  }}
                >
                  Back to consultation
                </button>
              </div>
            </div>
          )
        )
      }
      <div className={styles.rootLogo}>
        <span>
          <img src={images.logo} className={styles.logo} alt="logo" />
        </span>
      </div>

      {/*  Modals */}

      <SettingsModal isOpen={settingModal} closeModal={toggle} />
    </div>
  )
}
export default Navbar
